import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";
const GENERIC_URL = "https://eviq.pro/app";
const GENERIC_TEXT =
  "I use EVIQ to track my EV's battery health — live SoH, warranty countdown, and a shareable Battery Passport. Check it out:";
const REFERRAL_TEXT =
  "I use EVIQ to track my EV's battery health — live SoH, warranty countdown, and a shareable Battery Passport. Join with my link:";

/** Referral-aware share payload. Subscribers share their personal referral
 *  link (earns them a free month — 1/quarter, max 4/yr); everyone else
 *  shares the generic app link. */
export function useReferralShare() {
  const [ref, setRef] = useState(null);

  useEffect(() => {
    let email = "";
    try { email = window.localStorage.getItem("eviq.subscription_email") || ""; } catch { /* noop */ }
    if (!email || !API) return;
    fetch(`${API}/api/referral/me?email=${encodeURIComponent(email)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j?.eligible) setRef(j); })
      .catch(() => {});
  }, []);

  return {
    isReferral: !!ref,
    url: ref?.link || GENERIC_URL,
    text: ref ? REFERRAL_TEXT : GENERIC_TEXT,
    code: ref?.code || null,
    monthsEarned: ref?.months_earned ?? 0,
    referrals: ref?.referrals ?? 0,
  };
}
